import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CopyableId } from '../CopyableText';

import { roleLabel } from '../../lib/labels';
import type { Role } from '../../types/api';
import { DetailField, DetailFieldGrid } from './DetailField';

export function RoleDetailPanel({ role }: { role: Role }) {
    const { t } = useTranslation();
    const empty = t('common.empty');

    return (
        <DetailFieldGrid>
            <DetailField label={t('fields.name')} value={roleLabel(role)} />
            <DetailField label={t('fields.description')} value={role.description ?? empty} />
            <DetailField
                label={t('fields.scope')}
                value={
                    <Badge variant="light" size="sm">
                        {role.scope}
                    </Badge>
                }
            />
            <DetailField label={t('fields.roleId')} value={<CopyableId id={role.id} />} />
            <DetailField
                label={t('fields.created')}
                value={role.createdAt ? new Date(role.createdAt).toLocaleString() : empty}
            />
        </DetailFieldGrid>
    );
}
